export default {
    data() {
        return {
            hasElements: null,
            elements: [],
        };
    },
    watch: {
        hasElements(newValue) {
            if (this.hasElements && this.elements.length === 0) {
                if (this.addElement === undefined) {
                    throw 'An instance with mixin QuestionWithMultipleElementsMixin ' +
                    'needs to implement addElement method';
                }
                this.addElement();
            }
            if(newValue === undefined || !newValue) {
                this.deleteAllElements();
            }
        }
    },
    methods: {
        deleteElement(index) {
            this.elements.splice(index, 1);
        },
        deleteAllElements() {
            this.elements = [];
        }
    },
};